import { useParams } from 'react-router-dom'
import CardLoader from 'balkerne-components/dashboard/CardLoader'
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import ViewForm from 'balkerne-components/ViewForm'
import { useFormInstances } from '../hooks/forms'
import FormatDate from 'balkerne-components/FormatDate'
import { useHistory } from 'react-router-dom'
import { FormPermissions, PermissionGate } from 'balkerne-core/roles'
import Page from '../components/Page'
import { RootState } from '../store'

const PropertyMitigations = () => {
  const { id: propertyId } = useParams()
  const history = useHistory()
  const user = useSelector((state: RootState) => state.auth.user)
  const { data: incidents, isLoading: loading } = useFormInstances({
    property_id: propertyId,
    type_id: 5,
    organisation_id: user.organisation.id,
    form_state: 'CLOSED',
  })

  const previousPath = {
    previousPathTitle: 'Risk Report',
    previousPathName: '/riskreport',
    previousPathState: {
      propertyForms: false,
    },
  }

  const columns: GridColDef[] = [
    {
      field: 'title',
      headerName: 'Title',
      width: 300,
      editable: false,
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 150,
      editable: false,
      valueGetter: params => {
        return params.row.template.template.type.title
      },
    },
    {
      field: 'category',
      headerName: 'Category',
      width: 150,
      editable: false,
      valueGetter: params => {
        return params.row.template.template.category.title
      },
    },
    {
      field: 'full_name',
      headerName: 'Author',
      width: 150,
      editable: false,
      valueGetter: params => {
        if (params.row.assignee !== null) return params.row.assignee.full_name
        else return 'No Assignee'
      },
    },
    {
      field: 'updated_at',
      headerName: 'Last Updated',
      width: 175,
      editable: false,
      valueGetter: params => FormatDate(params.row.updated_at),
    },
  ]

  return (
    <Page title="Risk Mitigations" size="lg">
      {loading ? (
        <CardLoader />
      ) : (
        <PermissionGate action={FormPermissions.ListCompleted}>
          <div style={{ height: '800px' }}>
            <DataGrid
              components={{
                Toolbar: GridToolbar,
              }}
              rows={incidents}
              loading={loading}
              columns={columns}
              disableColumnSelector={true}
              onRowDoubleClick={form => ViewForm(form, history, null, previousPath)}
              density="standard"
            />
          </div>
        </PermissionGate>
      )}
    </Page>
  )
}

export default PropertyMitigations
